import styled from 'styled-components';

export const SectionHeader = styled.h1`
  display: inline-flex;
  align-items: center;
  padding-left: 10px;
  margin-top: 0;
  color: #007ade;
  font-size: 20px;
`;
